import { ref } from 'vue';
import { useSpending } from './useSpending';
import { useAppState } from './useAppState';
import { usePolling } from './usePolling';
export function useSpendingPlans() {
    const spending = useSpending();
    const state = useAppState();
    const { poll } = usePolling('spendingPlans');
    const selectedPlan = ref(null);
    const managePlan = ref(false);
    function createPlan(plan, setFieldValue = null) {
        selectedPlan.value = plan;
        if (plan.plan && setFieldValue) {
            setFieldValue('Plan amount', plan.plan.amount);
        }
        managePlan.value = true;
    }
    function snapshotPlans() {
        return JSON.stringify(state.spendingPlansFull?.plans?.map((p) => ({
            id: p.classification?.id,
            amount: p.plan?.amount ?? null
        })));
    }
    function onPlanMutationComplete(planPage, options) {
        options.extractActivePlans();
        if (planPage && options.onPlanPageUpdate) {
            options.onPlanPageUpdate();
        }
        managePlan.value = false;
        if (options.closeDrawerNext.value) {
            if (options.closeDrawer)
                options.closeDrawer();
            options.closeDrawerNext.value = false;
        }
        options.setFieldValue('Plan amount', 0);
    }
    function updatePlan(plan, options) {
        const planPage = options.planPage !== undefined ? options.planPage : true;
        const newAmount = options.findFieldValue('Plan amount') || null;
        const newSpendingPlan = {
            "mgClassification": {
                "id": plan.classification.id,
                "key": plan.classification.key,
                "mgClassification": plan.classification.mgClassification,
                "mgSubClassification": plan.classification.mgSubClassification,
                "grandParentClassification": plan.classification.grandParentClassification,
                "iconPath": plan.classification.iconPath
            },
            "amount": newAmount
        };
        const before = snapshotPlans();
        spending.addSpendingPlan(newSpendingPlan, () => {
            poll({
                remaining: 5,
                interval: 1000,
                fetch: (onSuccess) => spending.getSpendingPlansFull(onSuccess, /* refreshCache*/ true, /* clearCache */ false, /* staleWhileRevalidate */ false),
                onPoll: () => { },
                shouldStop: () => snapshotPlans() !== before,
                onFinish: () => onPlanMutationComplete(planPage, options),
            });
        });
    }
    function extractActivePlans(spendingPlansFull) {
        return {
            plans: spendingPlansFull.plans
                .filter((plan) => plan.plan !== null)
                .map((plan) => {
                return {
                    classification: plan.classification,
                    plan: plan.plan
                };
            })
        };
    }
    function deletePlan(plan, options) {
        const planPage = options.planPage !== undefined ? options.planPage : true;
        const before = snapshotPlans();
        spending.getSpendingPlansLite(null, /* refreshCache */ false, /* clearCache */ true);
        spending.getSpendingPlansFull(null, /* refreshCache */ false, /* clearCache */ true);
        spending.deleteSpendingPlan(plan.plan.id, () => {
            poll({
                remaining: 5,
                interval: 1000,
                fetch: (onSuccess) => spending.getSpendingPlansFull(onSuccess, true, false, false),
                onPoll: () => { },
                shouldStop: () => snapshotPlans() !== before,
                onFinish: () => onPlanMutationComplete(planPage, options),
            });
        });
    }
    return {
        selectedPlan,
        managePlan,
        createPlan,
        updatePlan,
        extractActivePlans,
        deletePlan,
    };
}
